export const apartmentsGlobalSettings = {
  header: {
    title: "Configuración global",
    sub: "Aplica a los <strong>{count} apartamento</strong> de tu cuenta. | Aplica a los <strong>{count} apartamentos</strong> de tu cuenta.",
    globalChip: "GLOBAL",
  },
  sections: {
    activate: "Activar motor de reservas",
    payment: "¿Cuándo paga el huésped?",
    hold: "Tiempo de hold",
    request: "Modo solicitud",
    link: "Link para compartir",
  },
  motor: {
    activeTitle: "Motor activo",
    inactiveTitle: "Motor inactivo",
    activeDesc: "Los huéspedes pueden hacer reservas directamente desde tu enlace.",
    inactiveDesc: "Las reservas directas están desactivadas para todos tus apartamentos.",
    statusOn: "Activo",
    statusOff: "Inactivo",
  },
  payment: {
    onArrival: {
      name: "Pago a la llegada",
      hint: "Reserva gratis, paga al llegar.",
    },
    online: {
      name: "Pago online",
      hint: "Paga al confirmar la reserva.",
    },
  },
  common: {
    saving: "Guardando…",
    onlyOnlineBadge: "Solo pago online",
  },
  hold: {
    desc: "El calendario se bloquea mientras el huésped completa el pago.<br>Si no paga en el tiempo indicado, <strong>la disponibilidad se libera automáticamente</strong>.",
  },
  units: {
    min: "min",
    hour: "hora",
    hours: "horas",
  },
  request: {
    enabledTitle: "Solicitudes activadas",
    autoTitle: "Confirmación automática",
    enabledDesc: "El huésped envía una solicitud. Tú la apruebas o rechazas vía WhatsApp.",
    autoDesc: "La reserva se confirma automáticamente al completar el pago.",
    tagControl: "Tú controlas quién reserva",
    tagWhatsapp: "WhatsApp al recibir solicitud",
  },
  link: {
    desc: "El mismo enlace para todos tus apartamentos. Compártelo en tu bio, campañas o mensajes automáticos.",
    copyTitle: "Copiar",
    viewVisitor: "Ver como visitante",
    shareWhatsapp: "Compartir por WhatsApp",
  },
  callout: "Selecciona un apartamento en la barra lateral para configurar <strong>Tarifas</strong>, <strong>Promociones</strong> y <strong>Cargos</strong> de forma individual.",
  savebar: {
    unsaved: "Cambios de hold y modo solicitud sin guardar",
    save: "Guardar configuración",
  },
  toasts: {
    paymentUpdated: "Forma de pago actualizada.",
    paymentError: "No se pudo guardar la forma de pago.",
    saved: "Configuración guardada.",
    saveError: "No se pudo guardar.",
    linkCopied: "Link copiado.",
    copyError: "No se pudo copiar.",
  },
  share: {
    whatsappText: "Hola 👋 Te comparto el enlace para reservar: {link}",
  },
};
